// extracted by mini-css-extract-plugin
module.exports = {"banner":"J1_banner__5WL35"};